interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/3a201609-c37c-46ff-b6f2-4ea6229e386e.png" 
              alt="ESVICOL LTDA Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              ESVICOL LTDA
            </span>
          </div>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('vpn-service')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              VPN Service
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('privacy')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
